'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderToTransaction = orderToTransaction;

var _order = require('./order');

function orderToTransaction(_ref) {
  var currency = _ref.currency,
      number = _ref.number,
      itemTotal = _ref.itemTotal,
      email = _ref.email,
      locale = _ref.locale,
      firstname = _ref.billAddress.firstname,
      lineItems = _ref.lineItems;

  var items = lineItems.map(function (_ref2) {
    var quantity = _ref2.quantity,
        _ref2$variant = _ref2.variant,
        sku = _ref2$variant.sku,
        name = _ref2$variant.name,
        color = _ref2$variant.color,
        size = _ref2$variant.size,
        price = _ref2$variant.price,
        santaMariaProductId = _ref2$variant.santaMariaProductId,
        displayImage = _ref2$variant.displayImage;

    var _parseSku = (0, _order.parseSku)(sku),
        colorId = _parseSku.colorId;

    var productId = colorId ? santaMariaProductId + '-' + colorId : santaMariaProductId;

    return {
      name: name + ' ' + color + ' ' + size,
      price: price,
      quantity: quantity,
      productId: productId,
      imageURL: window.location.hostname + '/' + displayImage
    };
  });

  return {
    currency: currency,
    orderId: number,
    total: itemTotal,
    items: items,
    email: email,
    locale: (locale || '').replace('-', '_'),
    nickname: firstname
  };
}


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/bazaarvoice.js
// module id = 2336
// module chunks = 0